"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const parsePayload_1 = __importDefault(require("./parsePayload"));
const createModel = async (Model, payload, hooks = true, url) => {
    await Model._init();
    const config = { params: {}, global: Model.isGlobal };
    if (payload.locale && Model._client._project && payload.locale === Model._client._project.defaultLocale) {
        delete payload.locale;
    }
    const args = { payload, config };
    if (hooks) {
        const responses = await Model.execHook("preCreate", [args]);
        if (responses === null || responses === void 0 ? void 0 : responses.includes(false)) {
            return;
        }
    }
    let inserted;
    try {
        args.payload = (0, parsePayload_1.default)(args.payload);
        const req = Model._client._axios.post(url, args.payload, args.config).then(async (res) => {
            const { data } = res.data;
            const inserted = Model.hydrate(data);
            const insertedList = [].concat(inserted);
            Model.clearCache();
            Model.upsertStore(insertedList, true);
            if (hooks) {
                await Model.execHook("postCreate", [insertedList, null, args]);
            }
            return inserted;
        });
        inserted = await req;
    }
    catch (e) {
        if (hooks) {
            await Model.execHook("postCreate", [null, e, args]);
        }
        throw e;
    }
    return inserted;
};
exports.default = createModel;
